// extracted by mini-css-extract-plugin
module.exports = {"bkw-B":"B_bkw-B__DmCku"};